'use strict';

var buildDateRangeUnits = require('../internal/buildDateRangeUnits');

buildDateRangeUnits();


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar-date/range/build/buildDateRangeUnitsCall.js
// module id = 26
// module chunks = 1